import { BaseModal } from "../../../../../components/common/BaseModal/BaseModal";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import { PrintButtonArea } from "@4pace-print-button-area/core";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button } from "@mui/material";
import {
  useCsAttributes,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { Gateway } from "@plansoft-configuration-renderer/gateway";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

export const UtilsProductView = (): JSX.Element => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const sessionId = useSessionId();
  const atts = useCsAttributes();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [blobUrl, setBlobUrl] = useState<string>();

  const typeDesignationObj = atts.find(
    (att) => att.id === "A_TYPE_DESIGNATION",
  );

  let documentName = "";
  if (typeDesignationObj && typeDesignationObj.values) {
    documentName = typeDesignationObj.values[0].value;
  }
  if (documentName) {
    documentName = documentName.replace(/[\\./]/g, "_");
  } else {
    documentName = "WEG-DataSheet";
  }

  const handlePrintBlob = (blob: Blob): void => {
    setIsModalOpen(true);
    //const encodedDocName = encodeURI(documentName);
    //const fileHeader = ";headers=" + encodedDocName;
    setBlobUrl(URL.createObjectURL(blob));
  };
  console.log("handlePrintBlob is a", typeof handlePrintBlob);

  return (
    <>
      <Gateway into="configurator-footer-right">
        <PrintButtonArea
          queryClient={queryClient}
          areaIdentifier="printDataSheet"
          locale="en-US"
          printRequestParams={{
            quoteId: sessionId,
          }}
          options={{
            docServerBasePath: "/preview",
            orchestratorBasePath: "/preview",
            buttonSx: { textTransform: "uppercase" },
          }}
          fileName={documentName}
          //handleBlob={handlePrintBlob}
        />
      </Gateway>
      <BaseModal
        isOpen={isModalOpen && !!blobUrl}
        onClose={() => {
          setIsModalOpen(false);
        }}
        customSx={{
          height: "100vh",
          width: "calc(21cm + 32px)",
          maxWidth: "95vw",
          ">.MuiBox-root": {
            height: "100%",
            ">.MuiBox-root": {
              height: "100%",
              p: 0,
              display: "flex",
              flexDirection: "column",
            },
          },
        }}
        customBodySx={{ flexGrow: 1, p: 1 }}
      >
        <Box height="100%" display="flex" flexDirection="column">
          {/* <span>{blobUrl}</span> */}
          <Box display="flex" mb={1} justifyContent="flex-end">
            <Button
              component={Link}
              to={blobUrl}
              download={documentName}
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
            >
              {t("WEG:buttons.download")}
            </Button>
          </Box>
          <Box flexGrow={1}>
            <embed src={blobUrl} width="100%" height="100%" />
          </Box>
          {/*  <iframe
            id="iframe-printDataSheet"
            title={"fileviewer for " + documentName}
            width="100%"
            height="100%"
            src={blobUrl}
          /> */}
        </Box>
      </BaseModal>
    </>
  );
};
